/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Standards_Preset_Actions_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Standards preset actions" |
*
* @param {Standards_Preset_Actions_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const standards_preset_actions_aria_label = /** @type {((inputs?: Standards_Preset_Actions_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Standards_Preset_Actions_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Standards preset actions")
	if (locale === "de") return /** @type {LocalizedString} */ ("Standards preset actions")
	if (locale === "it") return /** @type {LocalizedString} */ ("Standards preset actions")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Standards preset actions")
	if (locale === "es") return /** @type {LocalizedString} */ ("Standards preset actions")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Standards preset actions")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Standards preset actions")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Standards preset actions")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Standards preset actions")
	return /** @type {LocalizedString} */ ("Standards preset actions")
});